export const ReceiveDamagedReasons = {
  DENIED_UNENFORCEABLE: "Denied, unenforceable",
};

export const ReceiveDamagedReasonLabels = {
  DENIED_UNENFORCEABLE: "Processed",
};
